// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Regulations_container__SrJNv {
  margin: 48px 0px;
  width: 97.2%;
}
.Regulations_headerRow__\\+Mqmr {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}
.Regulations_headerBox__OogTe {
  display: flex;
  flex-direction: column;
}
.Regulations_backButton__-P7fh {
  align-items: center;
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  height: 32px;
  width: fit-content;
}
.Regulations_backButtonArrow__gqTdo {
  fill: #7e818c;
  transition: fill 200ms ease-in-out;
}
.Regulations_backButton__-P7fh:hover .Regulations_backButtonArrow__gqTdo {
  fill: #cb9c2d;
  transition: fill 200ms ease-in-out;
}
.Regulations_backButtonText__7\\+kyd {
  color: #7e818c;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  transition: color 200ms ease-in-out;
}
.Regulations_backButton__-P7fh:hover .Regulations_backButtonText__7\\+kyd {
  color: #cb9c2d;
  transition: color 200ms ease-in-out;
}
.Regulations_content__nLan8 {
  display: flex;
  flex-direction: column;
  row-gap: 48px;
}
.Regulations_filesContainer__VVpSz {
  border: 1px solid rgba(209, 217, 226, 1);
  border-radius: 10px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.Regulations_filesHeaderRow__W7BrW {
  align-items: center;
  background-color: #f8f9fb;
  border-bottom: 1px solid #d1d9e2;
  display: flex;
  justify-content: space-between;
  padding: 16px 40px;
}
.Regulations_heading__m7A1y {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-align: left;
}
.Regulations_filesHeading__ee2sb {
  color: #5f6d7e;
  cursor: default;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.Regulations_fileInput__WSawE {
  display: none;
}
.Regulations_editButton__9KcH1 {
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  padding: 9px 16px;
}
.Regulations_editButton__9KcH1:hover {
  cursor: pointer;
}
.Regulations_editButtonDisabled__p6KVe {
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  opacity: 0.6;
  padding: 9px 16px;
}
.Regulations_editButtonDisabled__p6KVe:hover {
  cursor: not-allowed;
}
.Regulations_editButtonText__qRTZo {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  height: 22px;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-align: center;
  text-transform: capitalize;
  width: 104px;
}
.Regulations_filesContent__FXp9V {
  align-items: center;
  background-color: #fff;
  column-gap: 40px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 40px;
  min-height: 95px;
  padding: 24px;
}

.Regulations_regulations__zEHAd {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Regulations_regulations__zEHAd:hover {
  cursor: pointer;
}

.Regulations_h3__YsxOW {
  text-align: center;
  font-family: "Inter";
  font-weight: 600;
  font-size: 14px;
  color: #5f6d7e;
  text-transform: capitalize;
}

.Regulations_link__2zy01 {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.Regulations_filesContentEmpty__pCuoQ {
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-height: 95px;
  padding: 24px;
}
.Regulations_emptyContent__e5nWH {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 103px;
  width: 154px;
}
.Regulations_emptyContentIcon__YnZpd {
  height: 40px;
  opacity: 0.5;
  stroke: #5f6d7e;
  width: 40px;
}
.Regulations_emptyContentText__1mvM1 {
  color: #5f6d7e;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  text-align: center;
  opacity: 0.5;
}
.Regulations_uploadItemContent__P2U4- {
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  height: 103px;
  width: 154px;
  margin-left: 15%;
}
.Regulations_uploadItemIcon__lH2SE {
  stroke: #828d9a;
}
.Regulations_uploadedContent__qr1tM {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 103px;
  width: 154px;
}
.Regulations_uploadedContentIcon__fpbS0 {
  height: 40px;
  stroke: #5f6d7e;
  width: 40px;
}
.Regulations_uploadedContentText__nZXQy {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-break: anywhere;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 12px 0px 0px;
  text-align: center;
  text-transform: capitalize;
}
.Regulations_uploadedContentText__nZXQy:hover {
  cursor: pointer;
  text-decoration: underline;
}
.Regulations_editControlRow__iodm7 {
  align-items: center;
  border-top: 1px solid #d1d9e2;
  column-gap: 16px;
  display: flex;
  justify-content: center;
  height: 76px;
}
.Regulations_cancelButton__hDv1j {
  align-items: center;
  background-color: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 212px;
}
.Regulations_cancelButtonText__MBJk4 {
  color: #808080;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
}
.Regulations_saveButton__kxwus {
  align-items: center;
  background-color: #cb9c2d;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 212px;
}
.Regulations_saveButtonText__lqk-o {
  color: #ffffff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.Regulations_removeItemButton__vvtI- {
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 64px;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  margin: -5px 0px 0px 25px;
  position: absolute;
  width: 24px;
}
.Regulations_removeItemIcon__i5sM5 {
  stroke: #5f6d7e;
}

.Regulations_backButton__-P7fh {
  display: none;
}
.Regulations_backButtonArrow__gqTdo {
  fill: #7e818c;
  transition: fill 200ms ease-in-out;
}
.Regulations_backButton__-P7fh:hover .Regulations_backButtonArrow__gqTdo {
  fill: #cb9c2d;
  transition: fill 200ms ease-in-out;
}
.Regulations_backButtonText__7\\+kyd {
  color: #7e818c;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  transition: color 200ms ease-in-out;
}
.Regulations_backButton__-P7fh:hover .Regulations_backButtonText__7\\+kyd {
  color: #cb9c2d;
  transition: color 200ms ease-in-out;
}

.Regulations_MobileNav__miicu,
.Regulations_mobileTitle__tGcqn {
  display: none;
}

.Regulations_selectedFilesInput__5Z8jK {
  border: none;
  overflow: scroll;
  width: 140px;
  height: 40px;
  color: #5f6d7e;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.Regulations_noFiles__e3ZL\\+ {
  width: 0;
}

.Regulations_selectedFilesInput__5Z8jK:focus {
  outline: none;
}

@media screen and (max-width: 1300px) {
  .Regulations_headerRow__\\+Mqmr {
    display: none;
  }
  .Regulations_container__SrJNv {
    margin: 20px 3%;
    width: 94%;
  }
  .Regulations_backButton__-P7fh {
    align-items: center;
    column-gap: 16px;
    cursor: pointer;
    display: flex;
    height: 32px;
    width: fit-content;
    margin: 20px 35px;
  }
  .Regulations_MobileNav__miicu,
  .Regulations_mobileTitle__tGcqn {
    display: block;
  }

  .Regulations_mobileTitle__tGcqn {
    padding-left: 35px;
  }
  .Regulations_uploadItemContent__P2U4- {
    margin-left: 0;
  }
}

@media screen and (max-width: 1000px) {
  .Regulations_filesContent__FXp9V {
    grid-template-columns: repeat(4, 1fr);
    column-gap: 30px;
    padding: 20px 15px;
  }
}

@media screen and (max-width: 800px) {
  .Regulations_filesContent__FXp9V {
    grid-template-columns: repeat(3, 1fr);
  }
  .Regulations_filesHeaderRow__W7BrW {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Regulations_uploadItemContent__P2U4- {
    margin-left: 10%;
  }
}

@media screen and (max-width: 650px) {
  .Regulations_filesContent__FXp9V {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
  .Regulations_container__SrJNv {
    margin: 20px 5%;
    width: 90%;
  }
  .Regulations_heading__m7A1y {
    font-size: 32px;
  }
  .Regulations_mobileTitle__tGcqn {
    padding-left: 25px;
  }
  .Regulations_backButton__-P7fh {
    margin: 20px 25px;
  }
}

@media screen and (max-width: 525px) {
  .Regulations_filesHeaderRow__W7BrW {
    padding: 16px 30px;
    gap: 15px;
  }
  .Regulations_editButton__9KcH1,
  .Regulations_editButtonDisabled__p6KVe {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .Regulations_saveButton__kxwus {
    width: 50%;
  }
  .Regulations_cancelButton__hDv1j {
    width: 35%;
  }
  .Regulations_editControlRow__iodm7 {
    gap: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/documents/components/regulations/Regulations.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;;IAEE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;;IAEE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;AACF","sourcesContent":[".container {\n  margin: 48px 0px;\n  width: 97.2%;\n}\n.headerRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 40px;\n}\n.headerBox {\n  display: flex;\n  flex-direction: column;\n}\n.backButton {\n  align-items: center;\n  column-gap: 16px;\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  width: fit-content;\n}\n.backButtonArrow {\n  fill: #7e818c;\n  transition: fill 200ms ease-in-out;\n}\n.backButton:hover .backButtonArrow {\n  fill: #cb9c2d;\n  transition: fill 200ms ease-in-out;\n}\n.backButtonText {\n  color: #7e818c;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  transition: color 200ms ease-in-out;\n}\n.backButton:hover .backButtonText {\n  color: #cb9c2d;\n  transition: color 200ms ease-in-out;\n}\n.content {\n  display: flex;\n  flex-direction: column;\n  row-gap: 48px;\n}\n.filesContainer {\n  border: 1px solid rgba(209, 217, 226, 1);\n  border-radius: 10px;\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.filesHeaderRow {\n  align-items: center;\n  background-color: #f8f9fb;\n  border-bottom: 1px solid #d1d9e2;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 40px;\n}\n.heading {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-align: left;\n}\n.filesHeading {\n  color: #5f6d7e;\n  cursor: default;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.fileInput {\n  display: none;\n}\n.editButton {\n  background-color: #ffffff;\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  padding: 9px 16px;\n}\n.editButton:hover {\n  cursor: pointer;\n}\n.editButtonDisabled {\n  background-color: #ffffff;\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  opacity: 0.6;\n  padding: 9px 16px;\n}\n.editButtonDisabled:hover {\n  cursor: not-allowed;\n}\n.editButtonText {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  height: 22px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-align: center;\n  text-transform: capitalize;\n  width: 104px;\n}\n.filesContent {\n  align-items: center;\n  background-color: #fff;\n  column-gap: 40px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 40px;\n  min-height: 95px;\n  padding: 24px;\n}\n\n.regulations {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.regulations:hover {\n  cursor: pointer;\n}\n\n.h3 {\n  text-align: center;\n  font-family: \"Inter\";\n  font-weight: 600;\n  font-size: 14px;\n  color: #5f6d7e;\n  text-transform: capitalize;\n}\n\n.link {\n  text-decoration: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.filesContentEmpty {\n  align-items: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  min-height: 95px;\n  padding: 24px;\n}\n.emptyContent {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 103px;\n  width: 154px;\n}\n.emptyContentIcon {\n  height: 40px;\n  opacity: 0.5;\n  stroke: #5f6d7e;\n  width: 40px;\n}\n.emptyContentText {\n  color: #5f6d7e;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  opacity: 0.5;\n}\n.uploadItemContent {\n  border: 1px solid #e2e2e2;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n  height: 103px;\n  width: 154px;\n  margin-left: 15%;\n}\n.uploadItemIcon {\n  stroke: #828d9a;\n}\n.uploadedContent {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 103px;\n  width: 154px;\n}\n.uploadedContentIcon {\n  height: 40px;\n  stroke: #5f6d7e;\n  width: 40px;\n}\n.uploadedContentText {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-break: anywhere;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 12px 0px 0px;\n  text-align: center;\n  text-transform: capitalize;\n}\n.uploadedContentText:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.editControlRow {\n  align-items: center;\n  border-top: 1px solid #d1d9e2;\n  column-gap: 16px;\n  display: flex;\n  justify-content: center;\n  height: 76px;\n}\n.cancelButton {\n  align-items: center;\n  background-color: #ebebeb;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  height: 52px;\n  justify-content: center;\n  width: 212px;\n}\n.cancelButtonText {\n  color: #808080;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.saveButton {\n  align-items: center;\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  height: 52px;\n  justify-content: center;\n  width: 212px;\n}\n.saveButtonText {\n  color: #ffffff;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.removeItemButton {\n  align-items: center;\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  cursor: pointer;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  margin: -5px 0px 0px 25px;\n  position: absolute;\n  width: 24px;\n}\n.removeItemIcon {\n  stroke: #5f6d7e;\n}\n\n.backButton {\n  display: none;\n}\n.backButtonArrow {\n  fill: #7e818c;\n  transition: fill 200ms ease-in-out;\n}\n.backButton:hover .backButtonArrow {\n  fill: #cb9c2d;\n  transition: fill 200ms ease-in-out;\n}\n.backButtonText {\n  color: #7e818c;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  transition: color 200ms ease-in-out;\n}\n.backButton:hover .backButtonText {\n  color: #cb9c2d;\n  transition: color 200ms ease-in-out;\n}\n\n.MobileNav,\n.mobileTitle {\n  display: none;\n}\n\n.selectedFilesInput {\n  border: none;\n  overflow: scroll;\n  width: 140px;\n  height: 40px;\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.noFiles {\n  width: 0;\n}\n\n.selectedFilesInput:focus {\n  outline: none;\n}\n\n@media screen and (max-width: 1300px) {\n  .headerRow {\n    display: none;\n  }\n  .container {\n    margin: 20px 3%;\n    width: 94%;\n  }\n  .backButton {\n    align-items: center;\n    column-gap: 16px;\n    cursor: pointer;\n    display: flex;\n    height: 32px;\n    width: fit-content;\n    margin: 20px 35px;\n  }\n  .MobileNav,\n  .mobileTitle {\n    display: block;\n  }\n\n  .mobileTitle {\n    padding-left: 35px;\n  }\n  .uploadItemContent {\n    margin-left: 0;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .filesContent {\n    grid-template-columns: repeat(4, 1fr);\n    column-gap: 30px;\n    padding: 20px 15px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .filesContent {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .filesHeaderRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .uploadItemContent {\n    margin-left: 10%;\n  }\n}\n\n@media screen and (max-width: 650px) {\n  .filesContent {\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 20px;\n  }\n  .container {\n    margin: 20px 5%;\n    width: 90%;\n  }\n  .heading {\n    font-size: 32px;\n  }\n  .mobileTitle {\n    padding-left: 25px;\n  }\n  .backButton {\n    margin: 20px 25px;\n  }\n}\n\n@media screen and (max-width: 525px) {\n  .filesHeaderRow {\n    padding: 16px 30px;\n    gap: 15px;\n  }\n  .editButton,\n  .editButtonDisabled {\n    width: 20%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .saveButton {\n    width: 50%;\n  }\n  .cancelButton {\n    width: 35%;\n  }\n  .editControlRow {\n    gap: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Regulations_container__SrJNv`,
	"headerRow": `Regulations_headerRow__+Mqmr`,
	"headerBox": `Regulations_headerBox__OogTe`,
	"backButton": `Regulations_backButton__-P7fh`,
	"backButtonArrow": `Regulations_backButtonArrow__gqTdo`,
	"backButtonText": `Regulations_backButtonText__7+kyd`,
	"content": `Regulations_content__nLan8`,
	"filesContainer": `Regulations_filesContainer__VVpSz`,
	"filesHeaderRow": `Regulations_filesHeaderRow__W7BrW`,
	"heading": `Regulations_heading__m7A1y`,
	"filesHeading": `Regulations_filesHeading__ee2sb`,
	"fileInput": `Regulations_fileInput__WSawE`,
	"editButton": `Regulations_editButton__9KcH1`,
	"editButtonDisabled": `Regulations_editButtonDisabled__p6KVe`,
	"editButtonText": `Regulations_editButtonText__qRTZo`,
	"filesContent": `Regulations_filesContent__FXp9V`,
	"regulations": `Regulations_regulations__zEHAd`,
	"h3": `Regulations_h3__YsxOW`,
	"link": `Regulations_link__2zy01`,
	"filesContentEmpty": `Regulations_filesContentEmpty__pCuoQ`,
	"emptyContent": `Regulations_emptyContent__e5nWH`,
	"emptyContentIcon": `Regulations_emptyContentIcon__YnZpd`,
	"emptyContentText": `Regulations_emptyContentText__1mvM1`,
	"uploadItemContent": `Regulations_uploadItemContent__P2U4-`,
	"uploadItemIcon": `Regulations_uploadItemIcon__lH2SE`,
	"uploadedContent": `Regulations_uploadedContent__qr1tM`,
	"uploadedContentIcon": `Regulations_uploadedContentIcon__fpbS0`,
	"uploadedContentText": `Regulations_uploadedContentText__nZXQy`,
	"editControlRow": `Regulations_editControlRow__iodm7`,
	"cancelButton": `Regulations_cancelButton__hDv1j`,
	"cancelButtonText": `Regulations_cancelButtonText__MBJk4`,
	"saveButton": `Regulations_saveButton__kxwus`,
	"saveButtonText": `Regulations_saveButtonText__lqk-o`,
	"removeItemButton": `Regulations_removeItemButton__vvtI-`,
	"removeItemIcon": `Regulations_removeItemIcon__i5sM5`,
	"MobileNav": `Regulations_MobileNav__miicu`,
	"mobileTitle": `Regulations_mobileTitle__tGcqn`,
	"selectedFilesInput": `Regulations_selectedFilesInput__5Z8jK`,
	"noFiles": `Regulations_noFiles__e3ZL+`
};
export default ___CSS_LOADER_EXPORT___;
